import styled from 'styled-components'

const StyledRegisterView = styled.div``

export default StyledRegisterView
